// Document types that are not really a type.
//
// CONSUMER: shared (web prep screen + Workers send route).
//
// A file saved off an email is filed as `email_attachment`
// (workers/api/src/routes/email/save-attachment.ts): that says where it
// CAME FROM, not what it IS. Treated as a real type, it showed the
// sender "Filed as email_attachment" on Prepare & Send (Nate,
// 2026-10-13) and stopped the "What kind of document is this?" picker
// from ever asking, and the send route then refused to record the
// answer because the document "already had a type". One list, read by
// both, so the screen asking and the server keeping the answer can't
// disagree.

const PLACEHOLDER_DOCUMENT_TYPES: ReadonlySet<string> = new Set(["email_attachment"]);

export function isPlaceholderDocumentType(type: string | null | undefined): boolean {
  return typeof type === "string" && PLACEHOLDER_DOCUMENT_TYPES.has(type);
}

/** The document's real type, or null when it has none (or only a
 *  placeholder). */
export function realDocumentType(type: string | null | undefined): string | null {
  if (!type || isPlaceholderDocumentType(type)) return null;
  return type;
}
